import { createContext, type ReactNode, useContext, useMemo } from 'react';
import type { Me, TaskPolicy } from '../api/types';

export type Session = {
  me: Me;
  userId: string;
  isAdmin: boolean;
  isOwner: boolean;
  can: (scope: string) => boolean;
  policy: TaskPolicy;
};

const Ctx = createContext<Session | null>(null);

export function SessionProvider({ me, children }: { me: Me; children: ReactNode }) {
  const value = useMemo<Session>(() => {
    const scopes = new Set(me.scopes);
    return {
      me,
      userId: me.user.id,
      isAdmin: me.user.role === 'owner' || me.user.role === 'admin',
      isOwner: me.user.role === 'owner',
      can: (s) => scopes.has(s),
      policy: me.organization.taskPolicy,
    };
  }, [me]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

/** Поточний сеанс (лише всередині автентифікованої оболонки). */
export function useSession(): Session {
  const s = useContext(Ctx);
  if (!s) throw new Error('Сеанс недоступний поза автентифікованою оболонкою');
  return s;
}
